import { LogoMark } from '~/components/logo-mark';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="border-t border-[var(--color-line)] bg-[var(--color-paper)]">
      <div className="container px-4 py-6 md:px-6">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <Link
            className="flex items-center space-x-2 transition-colors hover:text-[var(--color-copper)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--color-copper)]"
            href="/"
          >
            <LogoMark />
            <span className="text-lg font-semibold text-[var(--color-ink)]">DataConnector-Pro</span>
          </Link>
          <p className="text-xs text-[var(--color-muted)]">
            © {new Date().getUTCFullYear()} DataConnector-Pro. All rights reserved.
          </p>
          <nav className="flex gap-4">
            <Link className="text-xs text-[var(--color-muted)] hover:text-[var(--color-copper)]" href="/terms">
              Terms
            </Link>
            <Link className="text-xs text-[var(--color-muted)] hover:text-[var(--color-copper)]" href="/privacy">
              Privacy
            </Link>
            {/* The uptime report, not /status: that page moved into the client portal and a public
                visitor clicking "Service Status" would land on a login. */}
            <a
              className="text-xs text-[var(--color-muted)] hover:text-[var(--color-copper)]"
              href="https://status.dataconnector-pro.com/status/uptime"
              rel="noreferrer"
              target="_blank"
            >
              Service Status
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
